import { AxiosError } from 'axios';
import { QueryFunction, QueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';

export function useGet<TQueryFnData, TData = TQueryFnData>(
  queryKey: QueryKey,
  queryFn: QueryFunction<TQueryFnData, QueryKey>,
  options?: Omit<UseQueryOptions<TQueryFnData, AxiosError, TData, QueryKey>, 'queryKey' | 'queryFn'> | undefined
) {
  return useQuery<TQueryFnData, AxiosError, TData, QueryKey>({
    ...options,
    queryKey,
    queryFn,
  });
}
